<template>
   <div :class="{'width-max-content position-relative' : !show_name}">
       <div class="d-flex align-items-center pointer justify-content-between dropdowns inside-submenu px-4" :class="{'text-white py-2' : show_name}" 
           @click="toggleSubMenu(menu_index)">
           <div class="d-flex">
               <i class="icon icon-chevron-right text-white" v-if="show_name"></i> 
               <div :class="{'width-max-content' : !show_name}">
                   <span class="fw-500">{{name}}</span> 
               </div>
           </div>
           <i class="icon icon-chevron-down" :class="{'text-white' : show_name}" :id="'chevron-inverse'+menu_index"></i> 
       </div>
       <div class="pl-5 mt-2" :class="{'h-0px' : show_name, 'submenu': !show_name}" style="overflow:hidden" :id="'submenu'+menu_index">
           <div class="pointer d-flex align-items-center fw-500" :class="{'width-max-content' : !show_name}" v-for="(submenu, submenu_index) in submenus" :key="submenu_index">
               <recursive-submenus v-if="submenu.hasOwnProperty('submenus') && submenu.submenus.length > 0"
                   v-bind="{
                       name: submenu.name,
                       submenus: submenu.submenus,
                       show_name: show_name,
                       menu_index: menu_index+''+submenu_index
                   }"
                   @toggleSubMenu="toggleSubMenu"
               />
               <router-link :to="submenu.route" v-else @click="submenu.selected = true"
                   class="text-decoration-none inside-submenu-router px-4 py-2" :class="{'text-white':show_name}">
                   <i class="icon icon-chevron-right" v-if="show_name" :class="{'text-white':show_name}"></i> 
                   <span>{{submenu.name}}</span>
               </router-link>
           </div>
       </div>
   </div>
</template>

<script>
   export default {
       name: "recursive-submenus",
       props: {
           name: {
               type: String,
               required: true,
           },
           submenus: {
               type: Array,
               default: () => [],
           },
           show_name: {
               type: Boolean,
               default: false
           },
           menu_index: {
               type: String,
               default: ''
           }
       },
       methods: {
           toggleSubMenu(menu_number){
               // if(this.show_name){
                   let submenu = document.getElementById(`submenu${menu_number}`);
                   let chevron_inverse = document.getElementById(`chevron-inverse${menu_number}`)
                   submenu?.classList.toggle('submenu')
                   chevron_inverse?.classList.toggle('chevron-inverse')
               // }
           }
       },
       created(){

       }
   };
</script>

<style scoped>
ul{
   list-style-type: none !important;
}
.nav-link>span {
   padding-left: 5px !important;
   font-size: 14px;
   font-weight: 500;
   font-style: normal;
   font-stretch: normal;
   text-align: left;
   color: #4e4e4e;
}
.m-bottom{
   margin-bottom: 2px;
}
.ham-res{
   display: none;
}
@media screen and (max-width: 992px){
   .show-desktop{
       display: none !important;
   }
   .ham-res{
       display: block;
       position:absolute;
       top:25px;
       left:50px
   }
}
@media screen and (max-width: 900px) {
   .ham-res{
       top:20px;
   }
}
.mobile_menu{
   transition: .3s ease-in-out !important;
   background-color: transparent;
   min-width:210px !important;
   max-width: 500px;
   box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);
   position: fixed;
   z-index: 9;
   top:92px;
   height:100%;
   left: 0;
}
.mobile_menu_active{
   transition: transform .3s ease-in-out!important;
   transform: translateX(0%) !important;
}
.h-0px{
   height: 0px;
   transition: all .5s ease;
}
.submenu{
   height: max-content;
   transition: all .5s ease;
   padding-left: 23px !important;
}
.header-company{
   font-weight: 600;
   font-size: 20px;
   letter-spacing: 0.04em;
}
ul.menus-dropdown{
   overflow-x: hidden !important;
   max-height: 500px !important;
   overflow: scroll;   
   padding: 20px 10px 20px 15px;
}
ul.menus-dropdown li{
   color: #fff !important;
}
ul.menus-dropdown li a{
   padding: 0 9px;
}
.h-35px{
   height: 35px !important
}
.events-blocker{
   position: fixed;
   top: 0px;
   z-index: 99998;
   height: 100%;
   background: rgba(0, 0, 0, 0.5) !important;
   transform: translate(-100%);
}
.events_blocker_active{
   transform: translate(0%);
}
.text-decoration-none{
   text-decoration: none;
}
.text-white{
   color: #fff !important;
}
.icon-chevron-down{
   transition: transform .3s ease-in-out!important;
}
.chevron-inverse{
   transform: rotate(180deg);
}
.chevron-inverse-45deg{
   transform: rotate(180deg);
}
.hrms-logo{
   background-color: #00448b;
   border-radius: 5px;
   padding: 5px;
}
.product-name{
   line-height: 32px;
}
.top-corner-padding{
   padding: 25px 0 0 30px !important;
   margin-bottom: 25px;
}
.selected-route{
   background: #d5e1fa;
   padding: 0 10px 0 10px;
   border-radius: 50px;
   line-height: 30px;
   color: #fff !important
}
.selected-route-submenu{
   width:100%;
}
.selected-route.border-50px{
   border-radius: 50px
}
.selected-route.border-5px{
   border-radius: 5px
}
.menu-item:hover .dropdowns .arrow-left{
   display: block !important;
}
.menu-item:hover .dropdowns + .menus{
   display: block;
}
.fs-17{
   font-size: 17px;
}
.bg-img-menu{
   padding-top: 40px;
   padding: 40px 0;
   height: 100% !important;
   border-top-right-radius:50px;
   background-image: url(/static/images/new-theme2024/sidebar-bg.jpg);
}
.chevron-double-left{
   transform: rotate(180deg);
}
.chev-img{
   transition: all .5s ease;
}
.width-max-content{
   width: max-content !important;
}
.move-corner{
   position: absolute;
   right: -15px;
   top: 52px;
}
.hide {
 display: none;
}

.hov-menu:hover .hide {
 display: block;
}

.hov-menu{
   position: absolute;
   left:100px;
   top: 0px;
   background-color: #fff;
   border-radius:5px;
   border: solid 0.5px #f0ddb7;
   box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.hov-menu-header{
   background-color:#f0ddb7;
   border-radius: 5px 5px 0px 0px;
}
.hide:hover{
   display: block;
}
.hover-show-menu{
   margin: auto;
}
.hover-show-menu:hover .hide {
 display: block;
 color: #363636;
}
.w-100{
   width: 100% !important
}
.m-auto{
   margin: auto !important;
   /* display: block !important; */
}
.position-relative{
   position: relative;
}
.mobile-menu-min-width-sm{
   min-width: 75px !important;
}
.arrow-left{
   display: none;
   width: 0; 
   height: 0; 
   border-top: 10px solid transparent;
   border-bottom: 10px solid transparent; 
   border-right:10px solid #fff; 
   position: absolute;
   right: 0px;
}
@media screen and (max-width: 992px) {
   .mobile_menu{
       transform: translate(-100%);
       top: 0px;
       height: 100%;
       z-index: 99999 !important
   }
   .bg-img-menu{
       height: 100% !important;
   }
}
@media screen and (max-width: 768px) {
   .hide-sm-768px{
       display: none !important;
   }   
}

/* Submenu popover */
ul.menus {
   height: auto;
   min-width: max-content !important;
   width: max-content;
   max-width: max-content;
   background: #fff;
   position: absolute;
   top: -30px;
   left: 75px;
   z-index: 99;
   display: none;
   border: 0;
   border-radius: 7px;
   box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
   border: solid 0.5px #f0ddb7;
}

ul.menus li {
   display: block;
   width: 100%;
   text-transform: none;
   text-decoration: none;
   padding: 10px 5px;
   color: #363636;
}
li:hover ul.menus {
   display: block;
}
.menu-item:hover ul.menus {
   display: flex !important;
   flex-direction: column !important;
}
ul.menus a:hover {
   color: #00448b;
}
ul.menus .submenu {
   display: none;
   position: absolute;
   left: 180px;
   background: #fff;
   top: 0;
   width: max-content;
   max-width: 250px;
}

ul.menus .submenu li {
   background: #fff;
}
ul.menus .submenu li a{
   text-decoration: none;
}

ul.menus .has-submenu:hover .submenu {
   display: block;
}
ul,
li {
margin: 0 0;
padding: 0 0;
list-style: none
}

ul {
height: 35px
}

li {
float: left;
display: inline;
position: relative;
text-transform: uppercase
}

li:first-child {
border-left: none
}
.switch-user-prpfile{
   position: absolute;
   bottom:95px;
   /* left: 20px; */
}
.hr-res{
   margin: auto 25px auto 10px !important;
}
.pro_img{
   border-radius: 50%;
   border: 2px solid rgb(236, 241, 249);
   position: relative;
   left: 20px;
   margin: 10px auto;
}
.pro_img_expanded{
   left: 0px !important;
   margin: 10px;
}
@media screen and (max-width:992px) {
   .switch-user-prpfile{
       bottom:0px;
   }
}
.side-bar-overflow{
   height: 70%;
   overflow: auto;
}
</style>